import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
// 设置文件
import setting from '@/setting.js';
export default {
  namespaced: true,
  state: {
    // 是否开启页面过度动画
    active: setting.transition.active
  },
  actions: {
    /**
     * @description 设置开启状态
     * @param {Object} context
     * @param {Boolean} active 新的状态
     */
    set: function set(_ref, active) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var state, dispatch;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              state = _ref.state, dispatch = _ref.dispatch;
              // store 赋值
              state.active = active;
              // 持久化
              _context.n = 1;
              return dispatch('d2admin/db/set', {
                dbName: 'sys',
                path: 'transition.active',
                value: state.active,
                user: true
              }, {
                root: true
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * 从数据库读取页面过渡动画设置
     * @param {Object} context
     */
    load: function load(_ref2) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var state, dispatch;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              state = _ref2.state, dispatch = _ref2.dispatch;
              _context2.n = 1;
              return dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'transition.active',
                defaultValue: setting.transition.active,
                user: true
              }, {
                root: true
              });
            case 1:
              state.active = _context2.v;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  }
};